import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserData } from "../reducers/user.reducer";
import { getItemFromStorage } from "../utils/helper";
import { STORAGE_KEYS } from "../config/config";

const IsAuthenticated = async () => {
  const token = await getItemFromStorage(STORAGE_KEYS.TOKEN);
  const userInfo = await getItemFromStorage(STORAGE_KEYS.USER);
  // const { userInfo, token } = useSelector(selectUserData);
  return !!userInfo && !!token?.toString();
};

const withAuth = (Component) => {
  return (props) => {
    if (IsAuthenticated()) {
      return <Component {...props} />;
    } else {
      return <Navigate to="/login" />;
    }
  };
};

export default withAuth;